import { render, staticRenderFns } from "./walletParticulars.vue?vue&type=template&id=c24f64ec&scoped=true&"
import script from "./walletParticulars.vue?vue&type=script&lang=js&"
export * from "./walletParticulars.vue?vue&type=script&lang=js&"
import style0 from "./walletParticulars.vue?vue&type=style&index=0&id=c24f64ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24f64ec",
  null
  
)

export default component.exports